<div
  class="form-control {{ hasErrors ? 'has-errors' : hasWarnings ? 'has-warnings' : '' }} {{ isDisabled ? 'disabled' : '' }}"
>
  <label for="">
    @if (label) {
      <div class="label p2 fw-medium" [class.visibility-hidden]="isLabelInvisible">
        <ng-content select="[labelLeftIcon]"></ng-content>
        {{ label }}@if (isRequired) {*}
        <ng-content select="[labelRightIcon]"></ng-content>
      </div>
    }

    <div class="content-wrapper d-flex align-items-center
      {{ hasErrors ? 'content-wrapper--errors' : '' }}"
      [class.input-underline]="hasUnderline"
    >
      @if (icon) {
        <i class="{{ icon }} content-icon"></i>
      }

      <ng-content></ng-content>

      @if (hasErrors && showErrorIcon) {
        <i class="ri-spam-line error-icon"></i>
      }

      @if (hasWarnings && showErrorIcon) {
        <i class="ri-alert-line error-icon"></i>
      }
    </div>
  </label>
  <div class="helper-texts p3">
    <ng-content select="[helperTexts]"></ng-content>
  </div>
  <div class="errors p3" #errorContainer>
    @if (hasErrors) {
      <ng-content select="[errors]"></ng-content>
    }
  </div>

  @if (hasWarnings) {
    <div class="warnings p3">
      <ng-content select="[warnings]"></ng-content>
    </div>
  }
</div>
